import { getPriceDataByGroup, getPricesByProductFamily } from "../../api/Price";

export const  getPriceTableByBrandAndDate = (priceLogicData:Array<any>, brandId:any, date:Date) => {
  if(!priceLogicData || !priceLogicData.length) return {};
  let selectedPriceLogic = priceLogicData.find(group => {
    return (
    group.brand_id == brandId &&
    (group.start_date != null && date >= new Date(group.start_date)) && 
    (group.end_date != null && date <= new Date(group.end_date + " 23:59:59"))
    )
  }
  );

  if(!selectedPriceLogic){
    selectedPriceLogic = priceLogicData.find(group => 
      group.brand_id == brandId &&
      (group.start_date != null && date >= new Date(group.start_date)) && 
      (group.end_date == null )
    );
  }

  if(!selectedPriceLogic){
    selectedPriceLogic = priceLogicData.find(group => 
      group.brand_id == brandId &&
      (group.start_date == null) && 
      (group.end_date != null && date <=new Date(group.end_date + "23:59:59"))
    );
  }

  if(!selectedPriceLogic){
    selectedPriceLogic = priceLogicData.find(group => 
      group.brand_id == brandId &&
      (group.start_date == null && group.end_date == null)
    );
  }

  if (selectedPriceLogic) {
    return selectedPriceLogic.priceTable;
  } else {
    return {};
  }
}

export const calculatePricedEquipmentData = async (headerData:Array<any>, tableId : number|null, priceTableData : Array<any>, equipmentData : Array<any>, startDate:Date | null, endDate:Date | null) => {
  console.log(headerData);
  console.log(tableId);
  console.log(priceTableData);
  console.log(equipmentData);

  if(startDate === null || endDate === null){
    return equipmentData.map((item)=>({...item, price:0}));
  }

  const pricedEquipmentData = await Promise.all(equipmentData.map(async (item) => {

    let priceGroupId = 0;
    if(item.price_group_id) priceGroupId = item.price_group_id;
    else if(item.priceGroupIds){
      priceGroupId = item.priceGroupIds.split(',')[0] || 0;
    }

    const payload = {
      tableId: tableId || 0,
      groupId: priceGroupId,
    }
    const response:any = await getPriceDataByGroup(payload);
    const rows = await response.json();
    
    const updatedHeaderData = headerData.map((item) => {
      const value = rows.find((row:any) => row.point_id === item.id)?.value || 0;
      const pricePMS = item.milliseconds > 0 ? value / item.milliseconds : 0;
      const pricePH = item.milliseconds > 0 ? value / (item.milliseconds / (1000 * 60 * 60)) : 0;
      const pricePD = item.milliseconds > 0 ? value / (item.milliseconds / (1000 * 60 * 60 * 24)) : 0;
      return { ...item, value, pricePH, pricePD };
    });

    const diff = new Date(endDate).getTime() - new Date(startDate).getTime();

    // Select the smallest priced tier whose duration covers the rental length.
    // Sort ascending by milliseconds so ordering of headerData does not matter
    // and hourly (partial-day) slots are correctly chosen for same-day rentals.
    const sortedHeaderData = [...updatedHeaderData].sort((a:any, b:any) => a.milliseconds - b.milliseconds);
    const basedonPoint = sortedHeaderData.find((point:any) => point.value > 0 && point.milliseconds >= diff);

    console.log(sortedHeaderData);
    console.log(basedonPoint);

    let price = 0;
    if(basedonPoint){
      price = Math.round(basedonPoint.value*100)/100 * item.quantity;
    }else{
      const lastPoint = sortedHeaderData[sortedHeaderData.length-1];
      if(lastPoint){
        let extra_day = 0;
        for (const key in priceTableData) {
          if (priceTableData[key].group_id === item.price_group_id) {
            extra_day = priceTableData[key].extra_day;
          }
        }
        // console.log(lastPoint);
        // console.log(extra_day);
        price = Math.round(lastPoint.value*100)/100 * item.quantity + Math.round((diff - lastPoint.milliseconds)/(1000 * 60 * 60 * 24)) * extra_day;
      }
    }

    if(item.extras && item.extras.length>0){
      let extrasPrice = item.extras.reduce((total:any, extra:any) => total + extra.fixed_price, 0);
      price += extrasPrice;
    }
    
    return { ...item, price_group_id: priceGroupId, price };
  }));
  return pricedEquipmentData;
}

export const calculatePricedEquipmentDataWithVRPrices = async (
  equipmentData: Array<any>, 
  brandId: number, 
  deliveryMethod: 0 | 1, // 0: Customer Pickup, 1: Delivery by Company
  startDate: Date | null, 
  endDate: Date | null,
  startTime?: string | null,
  endTime?: string | null
) => {
  if (startDate === null || endDate === null) {
    return equipmentData.map((item) => ({ ...item, price: 0 }));
  }

  try {
    // Prepare items for the new API
    const items = equipmentData.map(item => ({
      family_id: item.family_id
    }));

    // Convert delivery_method to order_type string
    const orderType = deliveryMethod === 1 ? 'delivery' : 'pickup';

    const payload = {
      items,
      brand_id: brandId,
      order_type: orderType,
      start_date: startDate.toISOString().split('T')[0], // YYYY-MM-DD format
      end_date: endDate.toISOString().split('T')[0],     // YYYY-MM-DD format
      start_time: startTime || null,                     // HH:mm:ss format
      end_time: endTime || null                          // HH:mm:ss format
    };

    // Call the new API using promise wrapper
    const priceData = await new Promise((resolve, reject) => {
      getPricesByProductFamily(payload, (jsonRes, status, error) => {
        if (error) {
          console.error('API call error:', error);
          reject(error);
        } else if (status !== 200) {
          console.error('API returned non-200 status:', status);
          reject(new Error(`API returned status ${status}`));
        } else if (!jsonRes) {
          console.error('API returned no data');
          reject(new Error('No data returned from API'));
        } else {
          resolve(jsonRes);
        }
      });
    }).catch(error => {
      console.error('Promise wrapper error:', error);
      throw error;
    });
    
    if (!Array.isArray(priceData)) {
      console.error('Invalid response data from price API:', priceData);
      return equipmentData.map((item) => ({ ...item, price: 0 }));
    }

    // Create a map for easy lookup of prices by family_id
    const priceMap = new Map();
    priceData.forEach((familyPrice: any) => {
      priceMap.set(familyPrice.family_id, familyPrice.prices);
    });

    // Calculate duration in milliseconds (considering both date and time)
    let duration;
    if (startTime && endTime) {
      // Parse times and combine with dates for precise duration calculation
      const startDateTime = new Date(`${startDate.toISOString().split('T')[0]}T${startTime}`);
      const endDateTime = new Date(`${endDate.toISOString().split('T')[0]}T${endTime}`);
      duration = endDateTime.getTime() - startDateTime.getTime();
    } else {
      // Fallback to date-only calculation
      duration = new Date(endDate).getTime() - new Date(startDate).getTime();
    }

    const pricedEquipmentData = equipmentData.map((item) => {
      const familyPrices = priceMap.get(item.family_id);
      let price = 0;
      let selectedPriceTier = null;

      if (familyPrices && familyPrices.length > 0) {
        // Sort prices by duration (shortest to longest) to ensure proper selection
        const sortedPrices = familyPrices.sort((a, b) => a.milliseconds - b.milliseconds);
        
        console.log(`Family ID ${item.family_id}: Available prices:`, sortedPrices);
        console.log(`Rental duration: ${duration}ms (${duration / (1000 * 60 * 60)} hours)`);
        
        // Find the best price tier for the duration
        for (const priceTier of sortedPrices) {
          if (duration <= priceTier.milliseconds) {
            selectedPriceTier = priceTier;
            break;
          }
        }

        // If no exact match found, use the longest duration
        if (!selectedPriceTier && sortedPrices.length > 0) {
          selectedPriceTier = sortedPrices[sortedPrices.length - 1];
          console.log(`Duration exceeds all tiers, using longest tier:`, selectedPriceTier);
        } else if (selectedPriceTier) {
          console.log(`Selected price tier:`, selectedPriceTier);
        }

        if (selectedPriceTier) {
          price = selectedPriceTier.price * item.quantity;
        }
      } else {
        console.log(`No prices found for family ID ${item.family_id}`);
      }

      // Add extras price if any
      if (item.extras && item.extras.length > 0) {
        const extrasPrice = item.extras.reduce((total: number, extra: any) => total + extra.fixed_price, 0);
        price += extrasPrice;
        console.log(`Added extras price: ${extrasPrice} for item ${item.family_id}`);
      }

      console.log(`Final price for item ${item.family_id}: ${price}`);
      return { ...item, price, selectedPriceTier };
    });

    return pricedEquipmentData;
  } catch (error) {
    console.error('Error using new price API:', error);
    // Return original data with zero prices as fallback
    return equipmentData.map((item) => ({ ...item, price: 0 }));
  }
};
